import { LoginResponseInterface } from '../../core/interfaces/auth/login-response.interface';

export class Login {
    static readonly type = '[Auth] Login';
    constructor(public data: LoginResponseInterface) {}
}

export class SelectBrand {
    static readonly type = '[Auth] SelectBrand';
    constructor(public brand: any) {}
}

export class Logout {
    static readonly type = '[Auth] Logout';
    constructor() {}
}
